module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/promo-bg-d7a55c5d6ab8f88fadf66f10d8f90dd3.png";